import {
  Directive,
  HostListener,
  AfterContentInit,
  ContentChild,
  OnDestroy
} from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { MatDrawer } from '@angular/material/sidenav';

@Directive({
  selector: '[appSidebarToggle]'
})
export class SidebarToggleDirective implements AfterContentInit, OnDestroy {
  @ContentChild(MatDrawer) drawer: MatDrawer;

  private subscription: Subscription;

  constructor(private readonly router: Router) { }

  ngAfterContentInit(): void {
    this.changeMode(window.innerWidth);
    this.subscription = this.router.events
      .pipe(filter(event => event instanceof NavigationStart))
      .subscribe(() => window.innerWidth >= 768 || this.drawer.close());
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  @HostListener('window:resize', ['$event'])
  private onResize(event: Event): void {
    this.changeMode((event.target as Window).innerWidth);
  }

  private changeMode(width: number): void {
    if (width >= 768) {
      this.drawer.opened = true;
      this.drawer.mode = 'side';
    } else {
      this.drawer.opened = false;
      this.drawer.mode = 'over';
    }
  }
}
